var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaystackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6367 0H606.689C625.26 0 640.367 15.6524 640.367 35.0307V97.2253C640.367 116.521 625.262 132.26 606.689 132.26H33.6367C15.0643 132.26 0 116.523 0 97.2253V35.0307C0 15.6524 15.0643 0 33.6367 0ZM33.6367 347.173H606.689C625.26 347.173 640.367 362.865 640.367 382.163V444.442C640.367 463.738 625.262 479.391 606.689 479.391H33.6367C15.0643 479.391 0 463.738 0 444.442V382.163C0 362.865 15.0643 347.173 33.6367 347.173ZM33.6367 173.545H606.367C624.978 173.545 640 189.239 640 208.574V270.814C640 290.11 624.978 305.844 606.367 305.844H33.6367C15.0643 305.844 0 290.11 0 270.814V208.574C0 189.239 15.0643 173.545 33.6367 173.545Z",
    fill: "#09A5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaystackIcon);
export default __webpack_public_path__ + "static/media/paystack-icon.f6f2c35ca651e49a6d55eb1b70025ca7.svg";
export { ForwardRef as ReactComponent };